module.exports = __webpack_public_path__ + "static/template-f0dbfee37a86d46729c8384539399630.png";